import { tw as e } from "../../utils/tailwind.js";
const n = e`ease-in motion-safe:transition-colors motion-safe:duration-200`;
var t = /* @__PURE__ */ ((o) => (o.Default = "default", o.ImageOnly = "imageOnly", o.Full = "full", o))(t || {});
const a = "change";
export {
  a as CHANGE_EVENT,
  n as RADIO_CLASS_NAMES,
  t as VariantsEnum
};
